import styles from './HeaderSliderTeaser.module.scss'
import React from 'react'
import Link from 'next/link'
import { mediaFileObject } from '@/entities/interfaces'
import ResponsiveHeaderImageFull from '@/components/elements/media/ResponsiveHeaderImage/ResponsiveHeaderImageFull'

export interface HeaderSliderTeaserProps {
  title?: string
  text?: string
  image?: mediaFileObject
  link?: string
  targetBlank?: boolean
  slideIndex: number
}

const HeaderSliderTeaser = ({ title, link, text, image, targetBlank = false, slideIndex }: HeaderSliderTeaserProps) => {
  const content = (
    <div className={`${styles.slideInner}`}>
      {image && image.publicId && (
        <>
          <ResponsiveHeaderImageFull image={image} lazyload={slideIndex > 0} />
        </>
      )}
      <div className={styles.content}>
        {title && <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
        {text && <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />}
      </div>
    </div>
  )

  return (
    <>
      {link ? (
        <Link
          href={link}
          target={targetBlank ? '_blank' : '_self'}
          className={styles.slideWrap}
          data-tr-click="cms_block:header_slider_slide_teaser:click"
          data-tr-view="cms_block:header_slider_slide_teaser:view"
        >
          {content}
        </Link>
      ) : (
        <div className={styles.slideWrap}>{content}</div>
      )}
    </>
  )
}

export default HeaderSliderTeaser
